import React from "react";

import {
  SupportHeaderSection,
  ContactFormSection,
  SupportInfoAside,
} from "@/features/support";

/**
 * Support ana sayfası (/support) — login olmadan da erişilebilir.
 * Yeni talep formu + iletişim bilgileri aside'ı.
 */
const SupportPage: React.FC = () => {
  return (
    <div className="mx-auto flex w-full max-w-5xl flex-col gap-8 px-4 py-8 sm:py-10">
      <SupportHeaderSection />

      <div className="grid grid-cols-1 items-start gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <ContactFormSection />
        </div>
        <SupportInfoAside />
      </div>
    </div>
  );
};

export default SupportPage;
